import TkHelpIcon from "../../components/atoms/TkHelpIcon";

const headList = [
  {
    headTitle: (
      <>
        出生日
        <TkHelpIcon helpMessage="育児休業の対象となる子の出生日です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        育児休業開始日
        <TkHelpIcon helpMessage="女性の場合、育児休業開始日は出産日の翌日から57日目となります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        育児休業終了（予定）日
        <TkHelpIcon helpMessage="育児休業終了日は原則として子が満1歳に達する日までの期間（誕生日の前日）となります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        パパ・ママ育休プラス
        <TkHelpIcon helpMessage="パパ・ママ育休プラスの利用有無です。パパ・ママ育休プラスとは、通常、育児休業終了日は子が満1歳に達する日までの期間（誕生日の前日）となりますが、夫婦ともに育児休業を取得することで、1歳2か月まで延長することができる制度です。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        半年延長の理由
        <TkHelpIcon
          helpMessage={
            <>
              次の条件のいずれかに当てはまる場合、子が１歳6か月（又は2歳）に達するまでの間、育児休業を取得することができます。
              <br />
              １．保育所等に入所を希望しているが、1歳（又は1歳6か月）に達する日後の期間について、入所できない場合
              <br />
              ２．この養育を行っている配偶者であって、1歳（又は1歳6か月）に達する日後の期間について、子の養育を行う予定であった者が、死亡・負傷・疾病等、離婚等により、子を養育することができなくなった場合
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        産後パパ育休
        <TkHelpIcon helpMessage="当該育児休業申請が産後パパ育休にあたる場合は「有」となります。産後パパ育休とは、産後8週間以内に4週間（28日）を限度として2回に分けて取得できる休業のことで、1歳までの育児休業とは別に取得できる制度です。" />
      </>
    ),
  },
];

const headListWorkingDayNum = [
  {
    headTitle: (
      <>
        対象年月
        <TkHelpIcon helpMessage="出勤日数を登録することが必要な月です。業務に従事したとみなす日を含め、11日以上の出勤がある場合は、「なる月」になります。10日以下の場合は「育児休業月」となります。" />
      </>
    ),
  },
  {
    headTitle: (
      <>
        出勤日数
        <TkHelpIcon
          helpMessage={
            <>
              業務に従事したとみなす日を含め、出勤日数を入力してください。
              <br />
              詳しくは
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
];

export { headList, headListWorkingDayNum };
